module.exports = __webpack_public_path__ + "static/media/DeleteAddress.e8225671.svg";